import { render } from "./NetworkStatus.vue?vue&type=template&id=37ed2ca8&scoped=true"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"

import "./NetworkStatus.vue?vue&type=style&index=0&id=37ed2ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ed2ca8"]])

export default __exports__